import { graphql } from "react-relay";

export const asanaWrapperFragments = {
  viewer: graphql`
    fragment AsanaWrapper_viewer on Viewer {
      user {
        id
        orgs(first: 1000000) {
          edges {
            node {
              id
              asanaAccountErrorable {
                __typename
                ... on AsanaAccount {
                  hasAsanaCredentials
                }
                ... on GraphEntityError {
                  message
                  statusCode
                }
              }
              primaryOrgCalendar
              # FLOWSTATES
              flowStates(first: 1000000) {
                edges {
                  node {
                    id
                    flowKey
                    previousState
                    current {
                      state
                      percentComplete
                      errorMessage
                    }
                    pending {
                      state
                      percentComplete
                      errorMessage
                    }
                  }
                }
              }
            }
          }
        }

        # FLOWSTATES
        flowStates(first: 1000000) {
          edges {
            node {
              id
              flowKey
              previousState
              current {
                state
                percentComplete
                errorMessage
              }
              pending {
                state
                percentComplete
                errorMessage
              }
            }
          }
        }
      }
    }
  `,
};

export const asanaWrapperQuery = graphql`
  query AsanaWrapperQuery {
    viewer {
      ...AsanaWrapper_viewer
    }
  }
`;
